export default "__VITE_ASSET__BvVI8308__"